'use client';
import React, { ReactNode } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import  Conditional  from '@/components/shared/conditional/conditional.component';
import styles from './styles.module.scss';
import Image from 'next/image';

interface ITextWrapperProps {
  icon: any;
  textAbove: string;
  textBelow: string;
  optionalComponent?: ReactNode;
}

const TextWrapperComponent: React.FC<ITextWrapperProps> = ({
  icon,
  textAbove,
  textBelow,
  optionalComponent,
}) => {
  const hasOptionalComponent = !!optionalComponent;

  return (
    <div className={styles.container}>
      <Image src={icon.src} width={icon.width} height={icon.height} alt="icon" />

      <div className={styles.content_wrapper}>
        <div
          className={styles.text_wrapper}
          wrapper-variant={hasOptionalComponent ? 'optional-component' : ''}
        >
          <Typography variant="body1SemiBold" color={'#009B5D'}>
            {textAbove}
          </Typography>
          <Conditional condition={hasOptionalComponent}>
            <div className={styles.optional_component_wrapper}>{optionalComponent}</div>
          </Conditional>
        </div>
        <Typography variant="body1" color="#667085" style={{ whiteSpace: 'pre-wrap' }}>
          {textBelow}
        </Typography>
      </div>
    </div>
  );
};

export default TextWrapperComponent;
